<div class="card">
  <div class="card-body p-0">
    <app-base-list
      *ngIf="listConfig"
      [config]="listConfig"
      [data]="segments"
      [totalRecords]="segments.length"
      [loading]="loading"
      [paginator]="false"
      [rows]="1000" />
  </div>
</div>

<ng-template #actionsTpl let-row>
  <app-action-menu [items]="getMenuItems(row)"></app-action-menu>
</ng-template>
